import { useQuery } from "@tanstack/react-query";
import { CatsApi, UsersApi } from "../services";
import { AdminPageButton } from "../components/buttons/adminpageButton";
import { useState } from "react";
import { ArticlesUserManager } from "../components/articles/articlesUserManager";
import { Article } from "../models/article";
import { CatsManager } from "../components/cats/catsManager";
import { Cat } from "../models/cat";
import { ChangePasswordForm } from "../components/users/changePasswordForm";
import { ChangeUserDetails } from "../components/users/changeUserDetails";
import { FullUser } from "../models/fullUser";

export const UserPage = () => {
    const { data: user } = useQuery<FullUser>({
        queryKey: ['users'],
        queryFn: () => UsersApi.getCurrentUser(),
    });

    const { data: catsData } = useQuery<Cat[]>({
        queryKey: ['cats'],
        queryFn: () => CatsApi.getUsersCats(),
    });
    const cats = catsData ?? [];

    const { data: articlesData } = useQuery<Article[]>({
        queryKey: ['articles'],
        queryFn: () => UsersApi.getUsersArticlesAll(),
    });
    const articles = articlesData ?? [];

    const [section, setSection] = useState(0);

    if (!user) {
        return (
            <div>
                404
            </div>
        )
    }

    return (
        <div className="flex flex-col">
            <div className="mt-5 text-3xl text-center">
                {user.name} {user.surname}
            </div>
            <div className="px-5 pb-5">
                <div className="flex flex-col md:flex-row mt-5 bg-[#333333] justify-center">
                    <AdminPageButton label="Články" sectionToSet={1} setSection={setSection} />
                    {/* <AdminPageButton label="Fotogalerie" sectionToSet={3} setSection={setSection} /> */}
                    <AdminPageButton label="Kočky" sectionToSet={2} setSection={setSection} />
                    <AdminPageButton label="Heslo" sectionToSet={4} setSection={setSection} />
                    <AdminPageButton label="Detaily" sectionToSet={5} setSection={setSection} />
                </div>
                <div className="py-5">
                    {
                        section === 1 &&
                        <ArticlesUserManager articles={articles} />
                    }
                    {
                        section === 2 &&
                        <CatsManager cats={cats} />
                    }
                    {
                        section === 4 &&
                        <ChangePasswordForm />
                    }
                    {
                        section === 5 &&
                        <ChangeUserDetails user={user} />
                    }
                </div>
            </div>
        </div>
    )
}